// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
import { UseDateTimeDurationEventFragmentDoc } from '../../../Hooks/useDateTimeDuration/useDateTimeDuration.generated-types';
export type AllPropsEnquiryDetailsEventFragment = { __typename?: 'Event', name: string, budget: number, currency: string, attendees: number, location: string, cateringNeeds?: string | null, additionalNotes?: string | null, fromDateTime: string, toDateTime: string, spaceFacilities?: Array<{ __typename?: 'SpaceFacility', id: number, name: string }> | null, proposals: Array<{ __typename?: 'Proposal', UUID: string }> };

export const AllPropsEnquiryDetailsEventFragmentDoc = gql`
    fragment AllPropsEnquiryDetailsEvent on Event {
  name
  budget
  currency
  attendees
  location
  cateringNeeds
  additionalNotes
  spaceFacilities {
    id
    name
  }
  proposals {
    UUID
  }
  ...UseDateTimeDurationEvent
}
    ${UseDateTimeDurationEventFragmentDoc}`;